export const LEFT_PANEL_MIN_WIDTH = 94;
export const LEFT_PANEL_MAX_WIDTH = 200;

export const SEARCH_DEBOUNCE_INTERVAL = 1000;